import { useDispatch } from 'react-redux';
import { useMount } from 'react-use';

import { useUrlQuery } from '@hooks';

import { recordGAEvent } from '@app/store/analytics/actions';

let isExecutedOnce = false;

function DocumentFormDownloadPageRedirectionGAEventRecord() {
  const dispatch = useDispatch();
  const query = useUrlQuery();
  const titleQuery = query.get('title');

  useMount(() => {
    if (!isExecutedOnce && titleQuery) {
      isExecutedOnce = true;
      dispatch(recordGAEvent(titleQuery, '계약서양식_다운로드버튼', '다운로드페이지이동'));
    }
  });

  return null;
}

export default DocumentFormDownloadPageRedirectionGAEventRecord;
